import { getLocalStorageItem } from 'collaboration-sidebar/utils/localStorage';
export function shouldHideOnboardingForSelenium() {
  const isSeleniumRunning = document.cookie.includes('hs_selenium');
  const isOnboardingTourSeleniumRunning = !!getLocalStorageItem('selenium_onboarding_tour_enabled');
  return isSeleniumRunning && !isOnboardingTourSeleniumRunning;
}